"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagMapState = exports.ZOOM_SWITCH_JOBS_LEVEL = exports.ZOOM_SWITCH_LEVEL = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var modal_service_1 = require("../../components/modal/modal.service");
var dom_1 = require("../../dom");
var i18n_1 = require("../../i18n");
var services_1 = require("../../services");
var mobx_2 = require("../../state/mobx");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var projection_cache_1 = require("../google/projection.cache");
var bounding_string_1 = require("./bounding.string");
var BOUNDS_EXTEND_DELTA = 0.0005;
var BOUNDS_MIN_DISTANCE_METERS = 100;
var ZOOM_DETAIL_SWITCH_LEVEL = 19;
exports.ZOOM_SWITCH_LEVEL = 15;
exports.ZOOM_SWITCH_JOBS_LEVEL = 12;
var TagMapState = /** @class */ (function (_super) {
    tslib_1.__extends(TagMapState, _super);
    function TagMapState(tagState) {
        var _this = _super.call(this) || this;
        _this.boundString = mobx_1.observable.box('', { name: 'BoundsString' });
        _this.tagState = tagState;
        _this.initMapLocation();
        return _this;
    }
    TagMapState.prototype.initMapLocation = function () {
        var locationString = services_1.Services.Route.params.get('location');
        var parsedBounds = bounding_string_1.BoundingString.fromString(locationString);
        if (parsedBounds == null) {
            return;
        }
        var actualBounds = new google.maps.LatLngBounds();
        actualBounds.extend(parsedBounds);
        this.bounds = actualBounds;
        this.zoom = parsedBounds.zoom;
    };
    TagMapState.prototype.setMap = function (map) {
        this.map = map;
    };
    Object.defineProperty(TagMapState.prototype, "visibleTags", {
        get: function () {
            this.boundString.get();
            var tags = [];
            for (var _i = 0, _a = this.tagState.filteredTags; _i < _a.length; _i++) {
                var tag = _a[_i];
                var tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
                if (tagSummary == null || tagSummary.center == null) {
                    continue;
                }
                if (this.bounds == null || this.bounds.contains(tagSummary.center)) {
                    tags.push(tag.objectId);
                }
            }
            return tags;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagMapState.prototype, "visibleCollections", {
        get: function () {
            this.boundString.get();
            // trace();
            if (this.bounds == null) {
                return [];
            }
            var visibleCollections = [];
            var selectedTagId = page_state_1.CurrentState.inspectedTagId;
            var inspectedCollectionRevision = page_state_1.CurrentState.inspectedCollectionRevision;
            var inspectedCollection = null;
            for (var _i = 0, _a = this.tagState.filteredTags; _i < _a.length; _i++) {
                var tag = _a[_i];
                var tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
                if (tagSummary == null || tagSummary.center == null || tagSummary.bounds == null) {
                    continue;
                }
                var isTagSelected = selectedTagId === tag.objectId;
                var ne = tagSummary.bounds.ne;
                var sw = tagSummary.bounds.sw;
                var isTagInBounds = this.bounds.intersects({
                    north: ne.lat,
                    east: ne.lng,
                    south: sw.lat,
                    west: sw.lng
                });
                if (isTagInBounds === true) {
                    for (var _b = 0, _c = tagSummary.revisions; _b < _c.length; _b++) {
                        var revision = _c[_b];
                        var summary = store_1.AppStore.CollectionSummary.get(revision);
                        if (summary == null || summary.location == null) {
                            continue;
                        }
                        // Render the inspected collection last
                        if (inspectedCollectionRevision === summary.revision) {
                            inspectedCollection = summary.revision;
                        }
                        else if (isTagSelected) {
                            visibleCollections.push(summary.revision);
                        }
                        else if (this.bounds.contains(this.getLatLng(summary.location))) {
                            visibleCollections.push(summary.revision);
                        }
                    }
                }
            }
            if (inspectedCollection != null) {
                visibleCollections.push(inspectedCollection);
            }
            return visibleCollections;
        },
        enumerable: false,
        configurable: true
    });
    TagMapState.prototype.centerMap = function () {
        var visibleBounds = new google.maps.LatLngBounds();
        var summaries = [];
        for (var _i = 0, _a = this.tagState.filteredTags; _i < _a.length; _i++) {
            var tag = _a[_i];
            var tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
            if (tagSummary != null) {
                summaries.push(tagSummary);
            }
        }
        if (summaries.length > 0) {
            for (var _b = 0, summaries_1 = summaries; _b < summaries_1.length; _b++) {
                var summary = summaries_1[_b];
                if (summary.bounds != null) {
                    visibleBounds.extend(summary.bounds.ne).extend(summary.bounds.sw);
                }
            }
        }
        else {
            visibleBounds.extend({ lat: 80, lng: 180 });
            visibleBounds.extend({ lat: -80, lng: -180 });
        }
        this.map.fitBounds(visibleBounds);
        this.map.setCenter(visibleBounds.getCenter());
    };
    TagMapState.prototype.setBounds = function (bounds) {
        var newBounds = bounds.toUrlValue();
        if (newBounds === this.boundString.get()) {
            return;
        }
        this.bounds = bounds;
        this.boundString.set(bounds.toUrlValue());
    };
    TagMapState.prototype.setZoom = function (zoom) {
        if (zoom === this.zoom) {
            return;
        }
        if (zoom !== this.zoom) {
            projection_cache_1.PointCache.reset();
        }
        this.zoom = zoom;
    };
    TagMapState.prototype.zoomToId = function (type, id) {
        if (type === dom_1.DragonDomTypes.TAG) {
            return this.zoomToTag(id);
        }
    };
    TagMapState.prototype.zoomToTag = function (tagId) {
        var tag = this.tagState.filteredTags.find(function (t) { return t.objectId === tagId; });
        if (tag == null) {
            return null;
        }
        var tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
        if (tagSummary == null || tagSummary.bounds == null) {
            return null;
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Tag', tag.objectId, 1);
        var bounds = new google.maps.LatLngBounds(tagSummary.bounds.sw, tagSummary.bounds.ne);
        bounds = this.ensureAppropriateBounds(bounds);
        this.map.fitBounds(bounds);
    };
    Object.defineProperty(TagMapState.prototype, "showDetail", {
        get: function () {
            return this.zoom >= ZOOM_DETAIL_SWITCH_LEVEL;
        },
        enumerable: false,
        configurable: true
    });
    TagMapState.prototype.inspectHovered = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var revision, collectionSummary, canChange;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        revision = page_state_1.CurrentState.hoverId;
                        collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
                        if (collectionSummary == null) {
                            return [2 /*return*/];
                        }
                        // Mark the collection to link to
                        if (page_state_1.CurrentState.CollectionLink.isLinking) {
                            page_state_1.CurrentState.CollectionLink.completeLinking(collectionSummary);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.checkChangeCollection(collectionSummary.revision)];
                    case 1:
                        canChange = _a.sent();
                        if (canChange) {
                            page_state_1.CurrentState.setInspectedCollection(collectionSummary.revision);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TagMapState.prototype.zoomToCollection = function (revision) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var canChange, newRevision, latestSummary;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (revision === page_state_1.CurrentState.inspectedCollectionRevision) {
                            this.handleZoomToCollection(revision);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.checkChangeCollection(revision)];
                    case 1:
                        canChange = _a.sent();
                        if (!canChange) {
                            return [2 /*return*/];
                        }
                        newRevision = revision;
                        latestSummary = store_1.AppStore.CollectionSummary.getLatest(revision);
                        if (latestSummary != null) {
                            newRevision = latestSummary.revision;
                        }
                        page_state_1.CurrentState.setInspectedCollection(newRevision);
                        this.handleZoomToCollection(newRevision);
                        return [2 /*return*/];
                }
            });
        });
    };
    TagMapState.prototype.handleZoomToCollection = function (revision) {
        var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
        if (collectionSummary == null || collectionSummary.location == null) {
            return;
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Collection', collectionSummary.uuid, 1);
        var bounds = this.getLatLngBounds(collectionSummary.location);
        bounds = this.ensureAppropriateBounds(bounds);
        if (this.map != null) {
            this.map.fitBounds(bounds);
        }
    };
    TagMapState.prototype.checkChangeCollection = function (revision) {
        if (page_state_1.CurrentState.inspectedCollectionRevision == null) {
            return Promise.resolve(true);
        }
        if (page_state_1.CurrentState.inspectedCollectionRevision === revision) {
            return Promise.resolve(false);
        }
        return this.checkAndDiscardChanges();
    };
    TagMapState.prototype.checkAndDiscardChanges = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, summary;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!page_state_1.CurrentState.CollectionEdit.isDirty) {
                            page_state_1.CurrentState.CollectionEdit.discard();
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, modal_service_1.ModalService.open({
                                title: i18n_1.T.DISCARD_CHANGES_TITLE,
                                content: (0, i18n_1.Translate)(i18n_1.T.DISCARD_CHANGES_CONFIRM),
                                okName: i18n_1.T.DISCARD_CHANGES_DISCARD,
                                hasCancel: true
                            })];
                    case 1:
                        response = _a.sent();
                        summary = store_1.AppStore.CollectionSummary.get(page_state_1.CurrentState.inspectedCollectionRevision);
                        if (summary != null) {
                            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'Collection:discard', summary.uuid, 1);
                        }
                        if (response.ok) {
                            page_state_1.CurrentState.CollectionEdit.discard();
                        }
                        return [2 /*return*/, response.ok];
                }
            });
        });
    };
    TagMapState.prototype.ensureAppropriateBounds = function (bounds) {
        var distance = google.maps.geometry.spherical.computeDistanceBetween(bounds.getNorthEast(), bounds.getSouthWest());
        if (distance < BOUNDS_MIN_DISTANCE_METERS) {
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + BOUNDS_EXTEND_DELTA, bounds.getNorthEast().lng() + BOUNDS_EXTEND_DELTA);
            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - BOUNDS_EXTEND_DELTA, bounds.getNorthEast().lng() - BOUNDS_EXTEND_DELTA);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
        }
        return bounds;
    };
    TagMapState.prototype.getLatLng = function (loc) {
        return new google.maps.LatLng(loc.coordinates[1], loc.coordinates[0]);
    };
    TagMapState.prototype.getLatLngBounds = function (loc) {
        return new google.maps.LatLngBounds({
            lat: loc.coordinates[1],
            lng: loc.coordinates[0]
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], TagMapState.prototype, "zoom", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], TagMapState.prototype, "setMap", null);
    tslib_1.__decorate([
        mobx_1.computed.struct
    ], TagMapState.prototype, "visibleTags", null);
    tslib_1.__decorate([
        mobx_1.computed.struct
    ], TagMapState.prototype, "visibleCollections", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TagMapState.prototype, "centerMap", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagMapState.prototype, "setBounds", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagMapState.prototype, "setZoom", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagMapState.prototype, "zoomToId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagMapState.prototype, "zoomToTag", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TagMapState.prototype, "inspectHovered", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagMapState.prototype, "handleZoomToCollection", null);
    return TagMapState;
}(mobx_2.MobxState));
exports.TagMapState = TagMapState;
//# sourceMappingURL=tag.map.state.js.map